import { styled } from '@mui/material';

export const H3Styled = styled('h4')(({ theme }) => ({
  paddingTop: theme.spacings.unit(8),
  color: theme.colors.primaryText,
  fontSize: theme.fonts.utility.size(9),
  fontWeight: 600,
  margin: 0,
}));
